import { createTokens } from '@tamagui/core'

export const tokens = createTokens({
  color: {
    // Background colors
    background: '#0A0A0A',
    backgroundSecondary: '#1B1B18',
    backgroundTertiary: '#252520',

    // Orange accent gradient
    orangePrimary: '#FF6300',
    orangeSecondary: '#FF9D3A',
    orangeTertiary: '#FFE0AD',

    // Text colors
    textPrimary: '#FFFFFF',
    textSecondary: '#D1D1D1',
    textMuted: '#666666',

    // Sand neutrals
    sand100: '#DBDBD7',
    sand200: '#F3F3F2',
    sand300: '#EEEEEC',

    // Semantic colors
    success: '#22C55E',
    error: '#EF4444',
    warning: '#F59E0B',

    // Border and divider
    border: '#2A2A2A',
    divider: '#333333',

    // Card backgrounds
    cardBackground: '#141414',
    cardBackgroundHover: '#1A1A1A',
  },

  space: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28,
    8: 32,
    9: 36,
    10: 40,
    11: 44,
    12: 48,
    14: 56,
    16: 64,
    20: 80,
    24: 96,
    32: 128,
    '-1': -4,
    '-2': -8,
    '-3': -12,
    '-4': -16,
    '-5': -20,
    '-6': -24,
    true: 16,
  },

  size: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28,
    8: 32,
    9: 36,
    10: 40,
    11: 44,
    12: 48,
    14: 56,
    16: 64,
    20: 80,
    24: 96,
    32: 128,
    true: 16,
  },

  radius: {
    0: 0,
    1: 2,
    2: 4,
    3: 6,
    4: 8,
    5: 10,
    6: 12,
    7: 14,
    8: 16,
    9: 18,
    10: 20,
    true: 8,
  },

  zIndex: {
    0: 0,
    1: 100,
    2: 200,
    3: 300,
    4: 400,
    5: 500,
  },
})

export type AppTokens = typeof tokens
